import React from 'react'

import { BaseContent, ConfirmModal, useModalContext } from '@fourthwall/components'

export type UnavailableSlugModalProps = {
  suggestedSlug: string
  subtitle: string
  onConfirm: () => void
  onCancel: () => void
}

export const UnavailableSlugModal = ({
  suggestedSlug,
  subtitle,
  onConfirm,
  onCancel,
}: UnavailableSlugModalProps) => {
  const { close } = useModalContext()

  return (
    <ConfirmModal
      title="Provided domain is unavailable"
      size="medium"
      text={
        <BaseContent>
          <p>{subtitle}</p>
          <p>
            Please use: <br /> <strong>{suggestedSlug}</strong>
          </p>
        </BaseContent>
      }
      confirmLabel="Use suggested domain"
      onConfirm={onConfirm}
      onCancel={onCancel}
      close={close}
    />
  )
}
